import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className='bg-dark-lighter border-b  border-[#030c8a] shadow-md'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='flex justify-between items-center h-16'>
          {/* Logo */}
          <div className='flex items-center'>
            <Link to='https://natcopharmacy.com/' className='flex items-center gap-2'>
              <img src='logo.png?v=1.0' alt='Natco Pharmacy' className='h-8 w-auto ' />
            </Link>
          </div>

          {/* Navigation Links */}
          <div className='flex space-x-6'>
            <Link
              to='/'
              className='text-black hover:text-primary-light transition-colors text-base font-medium'
            >
              Home
            </Link>
            <Link
              to='/about'
              className='text-black hover:text-primary-light transition-colors text-base font-medium'
            >
              About
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
